export const STORAGE_KEYS = {
  CLIENT: 'client',
  CLIENT_PROFILE: 'client-profile',
  ORDER: 'order',
  PARAMS: 'params',
  TOKEN: 'access-token',
  USER: 'user-info',
  VERSION_URL: 'version-url',
}
